function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1 16c0-.45.02-.897.06-1.342a.833.833 0 111.66.148c-.036.395-.053.793-.053 1.194 0 7.364 5.97 13.333 13.333 13.333 7.364 0 13.333-5.97 13.333-13.333 0-7.364-5.97-13.333-13.333-13.333-1.67 0-3.298.307-4.822.898a.833.833 0 01-.602-1.554A14.965 14.965 0 0116 1c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.594 5.167l-1.529 5.367-.811-2.849h-.74l1.181 4.148h.74l1.899-6.666h-.74zM2.18 9.313L1 5.167h.74l1.18 4.146h-.74zM4.797 5.167l-1.9 6.666h.741l1.898-6.666h-.74z",
  fill: "currentColor"
})));